import { apiGet } from '../client';
import { BusinessRatingsResponseSchema, type BusinessRatings } from '../schemas';

/** What customers said after their visits, newest first (agenda permission on the server). */
export function getBusinessRatings(limit = 20): Promise<BusinessRatings> {
  return apiGet(`/v1/business/ratings?limit=${limit}`, BusinessRatingsResponseSchema).then((result) => result.data);
}
